<template>
  <div class="wrapper-full" id="update">
    <el-dialog
      :modal="false"
      top="3vh"
      :title="$t('langcfg.txtUpdateApp')"
      width="850px"
      style="margin-left: 500px; margin-top: 100px; border: none; overflow: hidden"
      :visible="dialogVisible"
      :destroy-on-close="true"
      :show-close="false"
      center
    >
      <el-form label-position="left" label-width="200px">
        <br /><br /><br />
        <el-form-item label="IP:">
          <el-input
            style="margin-left: 20px"
            autofocus
            v-model="info.ip"
            @click.native.stop.prevent="handleClick('ip')"
            @touchend.native.stop.prevent="handleClick('ip')"
          ></el-input>
        </el-form-item>
        <br /><br /><br />
        <el-form-item label="Port:">
          <el-input
            style="margin-left: 20px"
            v-model="info.port"
            @click.native.stop.prevent="handleClick('port')"
            @touchend.native.stop.prevent="handleClick('port')"
          ></el-input>
        </el-form-item>
        <br /><br /><br />
        <el-form-item label="Path:">
          <el-input
            style="margin-left: 20px"
            v-model="info.path"
            @click.native.stop.prevent="handleClick('path')"
            @touchend.native.stop.prevent="handleClick('path')"
          ></el-input>
        </el-form-item>
        <br /><br /><br />
        <!-- <el-form-item label="UUID:" style="text-align: left">
          <label style="margin-left: 21px; font-size: 22px; color: white">{{
            uid
          }}</label>
        </el-form-item> -->
        <el-form-item :label="`${$t('langcfg.txtUpdateTip')}:`" style="text-align: left">
          <el-radio-group
            v-model="isUpdateTipVisible"
            text-color="#00ff00"
            style="margin-left: 20px"
          >
            <el-radio :label="true" text-color="#00ff00" @change="selectItem" style="width: 200px">
              {{ $t("langcfg.txtOpen") }}</el-radio
            >
            <el-radio :label="false" text-color="#00ff00" @change="selectItem" style="width: 200px">
              {{ $t("langcfg.txtClose") }}</el-radio
            >
          </el-radio-group>
        </el-form-item>
      </el-form>
      <span slot="footer">
        &nbsp; &nbsp;
        <el-button class="btn-operator" @click="hideDialog">{{
          $t("langcfg.txtCancel")
        }}</el-button>
        &nbsp; &nbsp;
        <el-button class="btn-operator" type="primary" @click="$emit('update')">{{
          $t("langcfg.txtOK")
        }}</el-button>
        <!-- <br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /> -->
      </span>
    </el-dialog>
  </div>
</template>
<script>
import EVENTS from "../../../bus";
import { Size, Message } from "../../../mixins";
import { saveUpdateSettings } from "../../../settings";
import { objectCopy } from "../../../shared/utils";
const exec = window.require("child_process").exec;
export default {
  name: "Update",
  data() {
    return {
      info: {
        ip: "47.98.209.109",
        port: "8088",
        path: "dea520update/MediWorks"
      },
      isUpdateTipVisible: true
    };
  },
  mixins: [Size, Message],
  watch: {
    dialogVisible(val) {
      if (val) {
        this.isUpdateTipVisible = window.updateSettings.isUpdateTipVisible;
        this.info = objectCopy(this.updateInfo);
      }
    }
  },
  props: {
    dialogVisible: false,
    uid: "",
    updateInfo: {
      ip: "47.98.209.109",
      port: "20",
      path: "dea520update/Mediworks"
    }
  },
  methods: {
    handleClick(key) {
      let self = this;
      this.$bus.$emit(EVENTS.spreadKeyBoard, self.info[key], (value) => {
        self.info[key] = value;
        this.$emit("save", self.info);
      });
    },
    selectItem(val) {
      window.updateSettings.isUpdateTipVisible = val;
      saveUpdateSettings(window.updateSettings);
    },
    hideDialog() {
      this.$emit("update:dialogVisible", false);
    }
  }
};
</script>
<style lang="less" scoped>
.el-button {
  font-size: 40px;
}
.btn-operator:hover {
  color: @btn-hover-color;
  i {
    color: @btn-hover-color;
  }
}
.btn-operator:active {
  background: @btn-active-color;
}
.box-shadow {
  border: none;
}
.el-dialog__footer {
  padding: 0px;
}
.el-dialog {
  -webkit-box-shadow: none;
  box-shadow: none;
}
.btn-operator {
  border: 1px gray solid;
  height: @header-fs+50px;
  width: 250px;
  font-size: 30px;
}
.el-form /deep/ .el-form-item__label {
  font-size: 30px;
  padding: 0px;
  line-height: 50px;
}
.el-form /deep/ .el-form-item {
  margin-top: 20px;
}
</style>
<style lang="less">
#update {
  .el-radio {
    height: 50px;
    line-height: 50px;
    padding: 0 20px;
  }
  .el-radio /deep/ .el-radio__input {
    vertical-align: -5px !important;
  }
  .el-dialog {
    -webkit-box-shadow: none;
    box-shadow: none;
  }
  .el-dialog__title {
    font-size: 35px;
    font-weight: 700;
  }
}
</style>



// WEBPACK FOOTER //
// src/mainInterface/components/settings/Update.vue